import ActionButton from 'components/atoms/Buttons/ActionButton'
import CustomCheckbox from 'components/atoms/CheckBox'
import RangeDatePicker from 'components/Calender/CalenderRangePicker'
import Pagination from 'components/molcules/Pagination'
import {RoundTableWrap} from 'components/Table/RoundTableBodyStyle'
import RoundTableHeader from 'components/Table/RoundTableHeader'
import SubTitle from 'components/Text/SubTitle'
import {fetchDomesticListAction} from 'features/payment/paymentSlice'
import {getDefaultPeriodString} from 'helpers/dateHelper'
import {useAppDispatch} from 'hooks'
import GetAppIcon from '@material-ui/icons/GetApp'
import React, {useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'
import useSalesPersonalUsage from 'features/sales/useSalesPersonalUsage'
import pagingHelper from 'helpers/pagingHelper'

const PackageTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-radius: 25% 10%;
  & td {
    border-bottom: 1px solid #e4e7eb;
    text-align: center;
    word-wrap: break-word;
    white-space: pre-wrap;
    padding: 10px;
    min-width: 80px;
    max-width: 100px;
  }
`

const PackageToolbar = styled.div`
  display: flex;
  justify-content: space-between;
`
const FilterWrap = styled.div`
  display: flex;
  gap: 20px;
`

const PersonalUsageTable = () => {
  const HeaderCells: HeadCell[] = [
    {id: '1', label: 'IPeriod'},
    {id: '2', label: 'IOrgNameShort'},
    {id: '3', label: 'IEmail'},
    {id: '4', label: 'IOrgProperty'},
    {id: '5', label: 'IJoin'},
    {id: '6', label: 'ICountry'},
    {id: '6', label: 'ISuccessFail'},
    {id: '6', label: 'IRemainCount'},
    {id: '6', label: 'IAmount'},
  ]

  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {personalUsageList, onSearch} = useSalesPersonalUsage()
  const items = personalUsageList?.items ?? []

  const [selection, setSelection] = React.useState<PeriodString>(
    getDefaultPeriodString(),
  )
  const [removePersonalMou, setRemovePersonalMou] = React.useState(false)
  const [removePersonalDemo, setRemovePersonalDemo] = React.useState(false)
  const [currentPage, setCurrentPage] = React.useState(0)

  const handleValue = (value: PeriodDate) => {
    const selectPeriod: PeriodString = {
      startDate: String(value.startDate),
      endDate: String(value.endDate),
    }
    setSelection(selectPeriod)
  }
  const handlePagination = (value: number) => {
    setCurrentPage(value)
    onSearch({
      beginDate: selection.startDate,
      endDate: selection.endDate,
      ignoreFree: false,
      forDownload: false,
      page: value + 1,
      size: 5,
    })
  }
  const handleCheckRemoveMou = () => setRemovePersonalMou(!removePersonalMou)
  const handleCheckRemoveDemo = () => setRemovePersonalDemo(!removePersonalDemo)

  useEffect(() => {
    if (removePersonalMou) {
      onSearch({
        beginDate: selection.startDate,
        endDate: selection.endDate,
        ignoreFree: true,
        forDownload: false,
        page: 1,
        size: 5,
      })
    }
  }, [removePersonalMou])
  // TODO: 데모 계정 삭제
  useEffect(() => {
    if (removePersonalDemo) {
      onSearch({
        beginDate: selection.startDate,
        endDate: selection.endDate,
        ignoreFree: true,
        forDownload: false,
        page: 1,
        size: 5,
      })
    }
  }, [removePersonalDemo])
  useEffect(() => {
    dispatch(fetchDomesticListAction())
    onSearch({
      beginDate: selection.startDate,
      endDate: selection.endDate,
      ignoreFree: false,
      forDownload: false,
      page: 1,
      size: 5,
    })
  }, [selection])

  return (
    <div style={{width: '100%', overflow: 'auto'}}>
      <SubTitle>{t('IPersonalUsageTitle')}</SubTitle>
      <PackageToolbar>
        <RangeDatePicker
          onChangeValue={handleValue}
          dateValue={{
            startDate: new Date(selection.startDate),
            endDate: new Date(selection.endDate),
          }}
        />
        <FilterWrap>
          <CustomCheckbox
            id='personalRemoveMou'
            checked={removePersonalMou}
            onChange={handleCheckRemoveMou}
            label={t('IRemoveFree')}
          />
          <CustomCheckbox
            id='personalRemoveDemo'
            checked={removePersonalDemo}
            onChange={handleCheckRemoveDemo}
            label={t('IRemoveDemo')}
          />
          <ActionButton startIcon={<GetAppIcon />} color='secondary'>
            {t('IExcelDownload')}
          </ActionButton>
        </FilterWrap>
      </PackageToolbar>
      <br />
      <PackageTable>
        {HeaderCells.map((item, index) => (
          <RoundTableHeader
            label={item.label}
            length={HeaderCells.length}
            index={index}
          />
        ))}
        {/* TODO: api의 response가 바뀌어야함 해당하는 response에 맞게 변경해야함  */}
        {items?.map((item, index) => (
          <RoundTableWrap key={index}>
            <td>{item.beginDate}</td>
            <td>{item.orgName}</td>
            <td>{item.email}</td>
            <td>{item.attribute}</td>
            <td>{item.attribute ?? '-'}</td>
            <td>{item.countryCode}</td>
            <td>{item.attribute}</td>
            <td>{item.countOfProducts ?? 0}</td>
            <td>{item.countOfProducts ?? 0}</td>
          </RoundTableWrap>
        ))}
      </PackageTable>
      {items.length !== 0 && (
        <Pagination
          totalPageCount={pagingHelper(personalUsageList?.total ?? 1, 5)}
          currentPageIndex={currentPage}
          itemCountPerPage={5}
          setCurrentPageIndex={handlePagination}
          onItemCountPerPageChanged={() => {}}
          isItemCountPerPageEnabled={false}
          loading={false}
        />
      )}
      {items.length === 0 && (
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 300,
            borderBottom: '1px solid #e0e0e0',
          }}
        >
          {t('INoData')}
        </div>
      )}
    </div>
  )
}
export default PersonalUsageTable
